import Api from './Api'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`socio/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    updateAll(dadoComercial) {
        return Api().patch(`socio/dadosComerciais`, dadoComercial);
    },
}